/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
//Used in ui-internal-activitypass, ui-internal-parkpass, ui-internal-pass, ui-pass
import { AlertType } from '../types/alert';

export const makeAlertReducers = (prefix: string) => {
    const addAlertType = `${prefix}ADD_ALERT`;
    const removeAlertType = `${prefix}REMOVE_ALERT`;
    const clearAlertsType = `${prefix}CLEAR_ALERTS`;

    return {
        alerts: (state = [], action: { type: string; payload: any }) => {
            if (typeof action.type === 'undefined' || !action.type.startsWith(prefix)) {
                return state;
            }

            switch (action.type) {
                case addAlertType:
                    return [...state, action.payload];
                case removeAlertType:
                    return state.filter((item) => item !== action.payload);
                case clearAlertsType:
                    return state.filter((item: AlertType) => {
                        if (item.group === action.payload) {
                            return false;
                        }
                        return true;
                    });
                default:
                    return state;
            }
        },
    };
};

export const makeAlertSelectors = (uiState: any) => {
    return {
        getAlerts: (state: any, group = '') => {
            if (!state[uiState] || !state[uiState].alerts) {
                return [];
            }

            return state[uiState].alerts.filter(
                (alert: AlertType) => alert.group === group
            );
        },
    };
};
